import { SVGProps } from 'react';

const DashboardIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M16.563 5.225a1.854 1.854 0 0 1 .937 1.623v6.07c0 .675-.37 1.296-.965 1.624L10.91 18.1a1.891 1.891 0 0 1-1.82 0l-5.625-3.558a1.855 1.855 0 0 1-.965-1.624v-6.07c0-.675.37-1.295.965-1.623L9.09 1.908a1.942 1.942 0 0 1 1.875 0l5.625 3.317h-.027Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12.917 7.858a.833.833 0 0 1 .416.729v2.723a.833.833 0 0 1-.429.728l-2.5 1.598a.833.833 0 0 1-.808 0l-2.5-1.598a.833.833 0 0 1-.43-.727V8.587a.833.833 0 0 1 .429-.729l2.5-1.488a.857.857 0 0 1 .833 0l2.5 1.49-.011-.002Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10 17.5V10L3.75 6.25M10 10l6.25-3.75M10 2.5v3.75M16.25 13.333l-2.917-1.666M6.667 11.667 3.75 13.333"
    />
  </svg>
);

export default DashboardIcon;
